/**
 * Normalize text for case-insensitive, diacritic-insensitive, punctuation-tolerant
 * substring search.
 *
 * Examples:
 *   "Viscose / Rayon"                    → "viscose rayon"
 *   "Lyocell / TENCEL™ Lyocell"          → "lyocell tencel lyocell"
 *   "Piñatex / Pineapple Leather"        → "pinatex pineapple leather"
 *   "GOTS — Global Organic Textile Std"  → "gots global organic textile std"
 *
 * This is the workhorse for the search boxes on /materials-guide and
 * /certifications: a user typing "tencel lyocell" or "pinatex" or
 * "viscose rayon" or "gots global" must hit the obvious matches.
 */
export function normalizeForSearch(input) {
  if (input == null) return "";
  const s = String(input);
  return s
    .normalize("NFD")               // split base char + combining accent
    .replace(/[\u0300-\u036f]/g, "") // strip combining accents (ñ → n, é → e)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")    // collapse all non-alphanumerics to space
    .trim()
    .replace(/\s+/g, " ");
}

/**
 * True if every whitespace-separated token in the query appears as a substring
 * in the normalized haystack. Lets the user type multiple words in any order.
 *
 *   matchesAllTokens("Lyocell TENCEL", "tencel lyocell") → true
 */
export function matchesAllTokens(haystack, query) {
  const q = normalizeForSearch(query);
  if (!q) return true;
  const h = normalizeForSearch(haystack);
  return q.split(" ").every((token) => h.includes(token));
}
